module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "navigation-desktop",
    class: {
      'navigation-desktop--scrolled': !_vm.$store.state.nav
    }
  }, [_c('div', {
    staticClass: "navigation-desktop__container"
  }, [_c('router-link', {
    staticClass: "navigation-desktop__logos",
    class: {
      'navigation-desktop__logos--inactive': _vm.$store.state.nav && _vm.$route.path == '/'
    },
    attrs: {
      "to": "/"
    }
  }, [(_vm.$route.path !== '/') ? _c('div', {
    staticClass: "navigation-desktop__logo-white"
  }, [_c('Icon', {
    attrs: {
      "name": "LogoWhiteHoriz"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "navigation-desktop__logo-color",
    class: {
      'navigation-desktop__logo-color--scrolled': !_vm.$store.state.nav
    }
  }, [_c('Icon', {
    attrs: {
      "name": "LogoColorHoriz"
    }
  })], 1)]), _c('div', {
    staticClass: "navigation-desktop__links"
  }, [_vm._l((_vm.links), function(link, i) {
    return (link.navigation && i !== 5) ? _c('router-link', {
      key: i,
      ref: "root",
      refInFor: true,
      staticClass: "navigation-desktop__link",
      class: {
        "navigation-desktop__link--scrolled": !_vm.$store.state.nav
      },
      attrs: {
        "to": link.path,
        "title": link.name
      },
      on: {
        "click": function($event) {
          return _vm.pageLink(link)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(link.name))]), (link.children) ? _c('div', {
      staticClass: "nav-desktop__dropdown"
    }, _vm._l((link.children), function(subLink, j) {
      return _c('router-link', {
        key: 'link-' + j,
        staticClass: "nav-desktop__dropdown-link",
        attrs: {
          "to": subLink.path,
          "title": subLink.name
        },
        domProps: {
          "innerHTML": _vm._s(subLink.name)
        }
      })
    }), 1) : _vm._e()]) : _vm._e()
  }), _vm._l((_vm.links), function(link, i) {
    return (link.navigation && i == 5) ? _c('router-link', {
      key: i,
      staticClass: "navigation-desktop__link",
      class: {
        'navigation-desktop__link--scrolled': !_vm.$store.state.nav
      },
      attrs: {
        "to": link.path,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(link.name)
      }
    }) : _vm._e()
  })], 2), _c('div', {
    staticClass: "navigation-desktop__contact"
  }, [_c('a', {
    staticClass: "navigation-desktop__phone",
    class: {
      'navigation-desktop__phone--scrolled': !_vm.$store.state.nav
    },
    attrs: {
      "href": _vm.props.acf.nav.phone_link
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.nav.phone)
    }
  }), _c('div', {
    staticClass: "navigation-desktop__appointment",
    class: {
      'navigation-desktop__appointment--scrolled': !_vm.$store.state.nav
    },
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Schedule Now")])])], 1), _c('transition', {
    attrs: {
      "name": "fade-in-modal"
    }
  }, [(_vm.showModal) ? _c('ModalSchedule', {
    on: {
      "closeScheduleModal": _vm.closeScheduleModal
    }
  }) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01279820","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation-desktop/navigation-desktop.pug
// module id = 539
// module chunks = 1